var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bk-gray-dark trick-3"},[_c('img',{attrs:{"src":require("../../../assets/images/preparare-formule/truc3.png"),"alt":"/"}}),_c('p',[_vm._v("3. Respectă ordinea în care adaugi pudra")]),_c('span',[_vm._v("Adaugă pudra numai după ce ai turnat apa deja în biberon/cănuță ca să eviți formarea cocoloașelor ce rămân nedizolvate..")])])
}]

export { render, staticRenderFns }